/**
 * Small string settings (auth tokens, last-used bike). Capacitor Preferences
 * on native; localStorage on the web. Never throws: storage may be blocked.
 */
import { Preferences } from '@capacitor/preferences'
import { hasPlugin, isNative } from './platform'

const useNative = () => isNative() && hasPlugin('Preferences')

export async function getPreference(key: string): Promise<string | null> {
  try {
    if (useNative()) return (await Preferences.get({ key })).value
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export async function setPreference(key: string, value: string): Promise<void> {
  try {
    if (useNative()) await Preferences.set({ key, value })
    else window.localStorage.setItem(key, value)
  } catch {
    // Storage unavailable (private mode, quota): the app keeps working in memory.
  }
}

export async function removePreference(key: string): Promise<void> {
  try {
    if (useNative()) await Preferences.remove({ key })
    else window.localStorage.removeItem(key)
  } catch {
    // ignore
  }
}
